import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Small, reusable "Need a CDA first?" callout.
 * Drop it above any enquiry form or on any industry / service page.
 * variant: 'banner' (default, full width) | 'inline' (compact one-liner)
 */
export const CdaCallout = ({ variant = 'banner', from }) => {
  const href = `/cda${from ? `?from=${encodeURIComponent(from)}` : ''}`;
  if (variant === 'inline') {
    return (
      <p className="text-sm text-gray-600" data-testid="cda-callout-inline">
        Prefer to sign a confidentiality agreement first?{' '}
        <Link to={href} className="font-semibold text-teal-700 underline underline-offset-2">Request our mutual CDA online</Link>
        {' '}· approved within one business day, accepted electronically.
      </p>
    );
  }
  return (
    <div className="rounded-xl border border-teal-200 bg-teal-50 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5" data-testid="cda-callout">
      <div className="flex-1">
        <div className="text-xs font-bold tracking-widest text-teal-700 uppercase">Confidentiality first</div>
        <div className="font-semibold text-gray-900 mt-0.5">Want a signed CDA before you tell us anything technical?</div>
        <div className="text-sm text-gray-700 mt-0.5">Our standard mutual agreement is requested, approved and accepted online. No printing, no scanning, normally in place within one business day.</div>
      </div>
      <Link to={href} className="inline-flex items-center justify-center rounded-md bg-teal-700 px-4 py-2 text-sm font-semibold text-white hover:bg-teal-800 whitespace-nowrap">Request a CDA</Link>
    </div>
  );
};

export default CdaCallout;
